import { Typography } from '@material-ui/core'

const NoContents = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Typography variant="h2">No Contents Available</Typography>
    </div>
  )
}

export default NoContents
